import React, { useEffect, useState } from "react"
import { Button, LogoLoader, Modal, NewTableAdv, SmartTooltip, StatusTags } from "../../../../../components";
import { mapTableRows } from "../../../../../utils";
import EditJobModal from "../../Modals/EditJobModal";
import { getLeadJobs } from "../../../../../redux/slices/bdmjobs/bdmjobsApi";
import { formatWords2 } from "../../../../../utils/stringUtils";
import { usePagination } from "../../../../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { totalCountStart } from "../../../../../redux/slices/totalCount/totalCountSlice";
import AddJobModal from "../../Modals/AddJobModal";

const Jobs = ({companyUiid}) => {
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openJobEditModal, setOpenJobEditModal] = useState(false);
    const [openJobAddModal, setOpenJobAddModal] = useState(false);
    const [selectedJob, setSelectedJob] = useState(null);
    const dispatch = useDispatch();
    const { page, limit, setPage, handleLimitChange } = usePagination(
            10,
            (newPage, newLimit) => {}
          );
    const { value } = useSelector((state) => state?.totalCount);
    const totalCount = value?.LeadCompanyJobCnt?.data || 0;
    const getDaysOld = (dateString) => {
        const today = new Date();
        const postedDate = new Date(dateString);

        const diffTime = today - postedDate;
        return Math.floor(diffTime / (1000 * 60 * 60 * 24));
    };
    const timeAgo = (dateString) => {
        if (!dateString) return "-";

        const now = new Date();
        const past = new Date(dateString);
        const seconds = Math.floor((now - past) / 1000);

        if (seconds < 60) return "Just now";

        const minutes = Math.floor(seconds / 60);
        if (minutes < 60) return `${minutes} min ago`;

        const hours = Math.floor(minutes / 60);
        if (hours < 24) return `${hours} hr${hours > 1 ? "s" : ""} ago`;

        const days = Math.floor(hours / 24);
        return `${days} day${days > 1 ? "s" : ""} ago`;
    };
    const formatDateTime = (dateString) => {
        if (!dateString) return "-";
        return new Date(dateString).toLocaleString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    };
    const leadJobStatus = {
        1: "Active",
        2: "Followup",
        3: "Declined",
        4: "Positive Response",
        5: "Hold by Client",
        6: "On Hold",
        7: "Interview L1",
        8: "Interview L2",
        9: "Interview L3",
        10: "Priority",
        11: "Filled",
        12: "Closed",
        13: "Agreement Sent",
        14: "Agreement Accepted",
    }
    const columns = [
        {
            key: "id",
            label: "ID",
        },
        {
            key: "postDate",
            label: "Post Date",
            render: (row) => (
                <span className="text-sm">
                    {formatDateTime(row?.postDate)}
                </span>
            ),
        },
        {
            key: "postDuration",
            label: "Post Duration",
            render: (row) => {
                return (
                    <span>{row?.postDuration}</span>
                );
            },
            getRowClass: (row) => {
                const daysOld = getDaysOld(row.postDate);
                if (daysOld >= 5) {
                    return "bg-primary-50";
                }
                return "";
            },
        },
        {
            key: "jobTitle",
            label: "Job Title",
        },
        {
            key: "location",
            label: "Location",
        },

        {
            key: "url",
            label: "URL",
            render: (row) => (
                <a
                    href={row?.url}
                    target="_blank"
                    className="text-info underline"
                    rel="noreferrer"
                >
                    Click
                </a>
            ),
        },
        {
            key: "noOfApplicants",
            label: "No Of Applicants Applied",
        },
        {
            key: "jobPoster",
            label: "Job Poster name",
        },
        {
            key: "posterTitle",
            label: "Poster Title",
        },
        {
            key: "status",
            label: "Status",
            render: (row) => <StatusTags tag={leadJobStatus[row?.status]} />,
        },
        {
            key: "",
            label: "Action",
            align: "right",
            render: (row) => (
                <SmartTooltip description={"Edit"} tooltipPosition="left" noicon>
                    <Button
                        type="icon"
                        color="blue"
                        icon="edit_square"
                        variant="text"
                        size="sm"
                        onClick={() => {
                            setSelectedJob(row._raw);
                            setOpenJobEditModal(true);
                        }}
                    />
                </SmartTooltip>
            ),
        },
    ];
    // const rows = [
    //     {
    //         id: "JB-101",
    //         postDate: "02 Feb 2026",
    //         postDuration: "5 days",
    //         jobTitle: "Frontend Developer",
    //         location: "Bangalore",
    //         url: "https://linkedin.com/jobs/view/101",
    //         noOfApplicants: 12,
    //         jobPoster: "Rahul Mehta",
    //         posterTitle: "HR Manager",
    //         status: "Active",
    //     },
    //     {
    //         id: "JB-102",
    //         postDate: "29 Jan 2026",
    //         postDuration: "8 days",
    //         jobTitle: "Backend Developer",
    //         location: "Hyderabad",
    //         url: "https://linkedin.com/jobs/view/102",
    //         noOfApplicants: 9,
    //         jobPoster: "Sneha Kapoor",
    //         posterTitle: "Talent Partner",
    //         status: "Open",
    //     },
    //     {
    //         id: "JB-103",
    //         postDate: "18 Jan 2026",
    //         postDuration: "12 days",
    //         jobTitle: "UI/UX Designer",
    //         location: "Mumbai",
    //         url: "https://linkedin.com/jobs/view/103",
    //         noOfApplicants: 17,
    //         jobPoster: "Amit Sharma",
    //         posterTitle: "Recruiter",
    //         status: "On Hold",
    //     },
    //     {
    //         id: "JB-104",
    //         postDate: "15 Jan 2026",
    //         postDuration: "15 days",
    //         jobTitle: "DevOps Engineer",
    //         location: "Pune",
    //         url: "https://linkedin.com/jobs/view/104",
    //         noOfApplicants: 6,
    //         jobPoster: "Neha Verma",
    //         posterTitle: "Senior HR",
    //         status: "Closed",
    //     },
    // ];

    const rows = jobs.map((item) => ({
        _raw: item,
        id: item?.uiid || "-",
        postDate: item?.addedOn || "-",
        postDuration: item?.postedDuration || "",
        jobTitle: formatWords2(item?.jobTitle || ""),
        location: [item?.location?.city, item?.location?.state].filter(Boolean).join(", ") || "",
        url: item?.jobUrl || "",
        noOfApplicants: item?.noOfApplicants || "",
        posterTitle: item?.posterTitle || "",
        status: item?.status || "-",
        jobPoster: item?.posterName || "",
        }));


    const mappedRows = mapTableRows(rows, columns);
      const fetchLeadJobs = async () => {
    try {
      setLoading(true);
        const params = {
            coll: "LeadJob",
            ret: `uiid jobTitle location jobUrl noOfApplicants status addedOn jobPoster posterTitle postedDuration posterName`,
            sort: JSON.stringify({ addedOn: -1 }),
            fil: JSON.stringify({
                companyId: { type: "NONE", value: companyUiid },
            }),
            lim: limit,
            pg: page
        }
      const res = await getLeadJobs(params);

      setJobs(res?.data?.data || []);
    } catch (err) {
      console.error("Failed to fetch lead jobs", err);
    } finally {
      setLoading(false);
    }
  };
    useEffect(() => {
  if (!companyUiid) return;
  dispatch(
        totalCountStart({
          collection: "leadjobs",
          coll: "LeadJob",
          tname: "LeadCompanyJobCnt",
          app: "ats",
          filters:{
             companyId: { type: "NONE", value: companyUiid },
            },
        })
      );

  fetchLeadJobs();
}, [companyUiid,limit, page]);

if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <LogoLoader />
      </div>
    );
  }

    return (
        <div>
            <NewTableAdv
                columns={columns}
                rows={mappedRows}
                serverPagination={true}
                totalCount={totalCount}
                page={page}
                limit={limit}
                onPaginationChange={setPage}
                onLimitChange={handleLimitChange}
                toolbarRight={{
                    search: true,
                    add: [

                        {
                            component: (
                                <>
                                    <Button
                                        title="Add Job"
                                        size="md"
                                        icon="add"
                                        onClick={() => setOpenJobAddModal(true)}
                                    />
                                </>
                            ),
                        },
                    ],
                }}
            />
            <Modal
                isOpen={openJobEditModal}
                onClose={() => setOpenJobEditModal(false)}
                title={"Edit"}
                titleColor={"primary"}
                width="max-w-5xl"
            >
                <EditJobModal
                    onCancel={() => setOpenJobEditModal(false)}
                    job={selectedJob}
                    onSuccess={() => {
                        setOpenJobEditModal(false);
                        fetchLeadJobs();
                    }}
                />
            </Modal>
            <Modal
                isOpen={openJobAddModal}
                onClose={() => setOpenJobAddModal(false)}
                title={"Add"}
                titleColor={"primary"}
                width="max-w-5xl"
            >
                <AddJobModal
                    companyUiid={companyUiid}
                    onCancel={() => setOpenJobAddModal(false)}
                    onSuccess={() => {
                        dispatch(
                        totalCountStart({
                        collection: "leadjobs",
                        coll: "LeadJob",
                        tname: "LeadCompanyJobCnt",
                        app: "ats",
                        filters:{
                            companyId: { type: "NONE", value: companyUiid },
                            },
                        })
                    );

                    fetchLeadJobs();
                    }}
                />
            </Modal>
        </div>
    )
}
export default Jobs;